import axios from 'axios';
import { baseUrl } from './helper';
import { toast } from 'react-toastify';
import aesjs from 'aes-js';
const handle401 = () => {
  sessionStorage.removeItem('auth');
  sessionStorage.removeItem('user');
  toast.error('Phiên đăng nhập hết hạn');
  window.location.replace('/account/login');
};

// ─── Global interceptor cho axios mặc định ───────────────────────────────────
// Tất cả các page dùng axios thẳng đều được xử lý 401 tự động
// Không cần sửa bất kỳ page nào
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) handle401();
    return Promise.reject(error);
  },
);

const instanceAuth = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let token = urlParams.get('token');

  if (token) {
    const key = [0, 1, 2, 5, 4, 5, 9, 7, 8, 9, 99, 11, 12, 0, 14, 65];
    const iv = [21, 22, 42, 24, 25, 56, 27, 29, 29, 88, 31, 95, 74, 67, 34, 36];

    const encryptedBytesDec = aesjs.utils.hex.toBytes(token);
    const aesCtrDec = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(iv));
    const decryptedBytes = aesCtrDec.decrypt(encryptedBytesDec);

    const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);

    token = decryptedText;
    sessionStorage.setItem('auth', decryptedText);
  } else {
    token = sessionStorage.getItem('auth');
  }
  const instance = axios.create({
    baseURL: `${baseUrl}/api/daily/`,
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token,
    },
  });
  instance.interceptors.response.use(
    (response) => response?.data,
    (error) => {
      if (error?.response?.status === 401) {
        sessionStorage.removeItem('auth');
        sessionStorage.removeItem('user');
        toast.error('Phiên đăng nhập hết hạn');
        window.location.replace('/account/login');
      }
      return Promise.reject(error?.response?.data);
    },
  );

  return instance;
};

const instanceFormData = () => {
  const token = sessionStorage.getItem('auth');

  const instance = axios.create({
    baseURL: `${baseUrl}/api/daily/`,
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-access-token': token,
    },
  });
  instance.interceptors.response.use(
    (response) => response?.data,
    (error) => Promise.reject(error?.response?.data),
  );

  return instance;
};

const instanceNoAuth = () => {
  const instance = axios.create({
    baseURL: `${baseUrl}/api/daily/`,
  });
  instance.interceptors.response.use(
    (response) => response?.data,
    (error) => Promise.reject(error?.response?.data),
  );

  return instance;
};
// const createInstance = (isAuthReqired = false) => {
//   let headers = {};

//   if (isAuthReqired) {
//     const token = sessionStorage.getItem("auth");

//     headers["x-access-token"] = token;
//   }

//   return axios.create({
//     baseURL: baseUrl,
//     headers,
//   });
// };

// const instanceAuth = createInstance(true);
// const instanceNoAuth = createInstance();

// instanceAuth.interceptors.response.use(
//   (response) => response?.data,
//   (error) => Promise.reject(error?.response?.data)
// );

export { instanceAuth, instanceNoAuth, instanceFormData };
